import React, { useContext } from "react";
import { Form, Checkbox } from "antd";
import { getFormItemLabel, getFormItemVaidation } from "../util/helpers";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import RestrictedContext from "../util/RestrictedContext";

const CheckBoxItem = (props) => {
  const { name, category, required, showLabel, onChange, disabled, style } =
    props;
  const restricted = useContext(RestrictedContext);
  const intl = useIntl();
  const label = getFormItemLabel(intl, category, name, null);
  const arr = [];
  if (required) {
    arr.push("required");
  }
  const rules = getFormItemVaidation(intl, label, arr);
  return (
    <Form.Item
      name={name}
      rules={rules}
      valuePropName="checked"
      label={showLabel ? label : null}
      onChange={onChange}
      style={style}
    >
      <Checkbox disabled={!restricted["hasWritePermission"] || disabled}>
        {showLabel ? "" : label}
      </Checkbox>
    </Form.Item>
  );
};

CheckBoxItem.propTypes = {
  name: PropTypes.string,
  category: PropTypes.string,
  required: PropTypes.bool,
  showLabel: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default CheckBoxItem;
